import i18next from "src/i18n/config";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";

import { OrganizationDetailsSection } from "./components/OrganizationDetailsSection/OrganizationDetailsSection";
import { WorkspaceDetailsSection } from "./components/WorkspaceDetailsSection/WorkspaceDetailsSection";
import { WorkspaceSelector } from "./components/WorkspaceSelector/WorkspaceSelector";
import { WorkspaceStatisticsSection } from "./components/WorkspaceStatisticsSection/WorkspaceStatisticsSection";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";
import { WorkspaceSubPageLayout } from "./WorkspaceSubPageLayout";

function WorkspacesIntroPage() {
    const { workspace, allowedToEditWorkspace } = useWorkspacePageAccess();

    return (
        <WorkspaceSubPageLayout disableExpiredWrapper>
            <WorkspaceSelector />

            {workspace ? (
                <>
                    <WorkspaceDetailsSection
                        key={`details-${workspace.id}`}
                        workspace={workspace}
                        canEdit={allowedToEditWorkspace}
                    />
                    <WorkspaceStatisticsSection workspace={workspace} />
                    <OrganizationDetailsSection
                        key={`organization-${workspace.id}`}
                        workspace={workspace}
                        canEdit={allowedToEditWorkspace}
                    />
                </>
            ) : null}
        </WorkspaceSubPageLayout>
    );
}

export default withMetaDescription(WorkspacesIntroPage, {
    title: i18next.t("pages:workspacePage.intro.metaTitle"),
    description: i18next.t("pages:workspacePage.intro.metaDescription"),
});
